import type { PropsWithChildren } from 'react'
import { makeStyles } from '@mui/styles'
import {
  ButtonWithLoader,
  type ButtonWithLoaderProps,
} from '@pbt/pbt-ui-components'

const useStyles = makeStyles(
  () => ({
    button: {
      height: 40,
      minWidth: 100,
      marginRight: 10,
    },
  }),
  { name: 'MigrationStepActionButton' },
)

const MigrationStepActionButton = ({
  children,
  ...props
}: PropsWithChildren<ButtonWithLoaderProps>) => {
  const classes = useStyles()

  return (
    <ButtonWithLoader className={classes.button} {...props}>
      {children}
    </ButtonWithLoader>
  )
}

export default MigrationStepActionButton
